import { Collapse, Divider, Typography } from "antd";
import React from "react";
import { EmployeeForm } from "../CreateEmployee/Forms/EmployeeForm";
import { PermissionsForm } from "../CreateEmployee/Forms/PermissionsForm";

const EditEmployeeForm = ({
  form,
  employee,
  isIntegrationAuthEnabled,
  onFinish,
  onChange,
  employeeInitialValues,
  permissions
}) => {
  const PANELS_KEYS = {
    EMPLOYEE: "employeeData",
    ACCESS: "accessData"
  };

  return (
    <>
      <Typography.Title level={2} color={"#166889"}>
        {`Editar funcionário > ${employee.first_name} ${employee.last_name}`}
      </Typography.Title>
      <Divider style={{ borderTop: "2px solid rgba(0, 0, 0, 0.06)" }} />
      <Collapse
        ghost
        defaultActiveKey={[PANELS_KEYS.EMPLOYEE, PANELS_KEYS.ACCESS]}
      >
        <Collapse.Panel
          header={
            <>
              <b>Dados do funcionário</b> <br /> Preencha as informações
              pessoais do funcionário.
            </>
          }
          key={PANELS_KEYS.EMPLOYEE}
        >
          <Divider
            style={{
              marginBottom: 24,
              marginTop: 0,
              borderTop: "2px solid rgba(0, 0, 0, 0.06)"
            }}
          />
          <EmployeeForm
            form={form}
            onFinish={onFinish}
            initialValues={employeeInitialValues}
            onChange={onChange}
          />
        </Collapse.Panel>
        <Collapse.Panel
          header={
            <>
              <b>Gerenciar acessos</b> <br /> Habilite os acessos do funcionário
              aos sistema permitidos abaixo.
            </>
          }
          key={PANELS_KEYS.ACCESS}
          collapsible={isIntegrationAuthEnabled ? undefined : "disabled"}
        >
          <Divider
            style={{
              marginBottom: 24,
              marginTop: 0,
              borderTop: "2px solid rgba(0, 0, 0, 0.06)"
            }}
          />
          <PermissionsForm
            form={form}
            onFinish={onFinish}
            permissions={permissions}
          />
        </Collapse.Panel>
      </Collapse>
    </>
  );
};

export default EditEmployeeForm;
